import React from 'react';
import {func, string, object, array} from 'prop-types';
import {createFragmentContainer, graphql} from 'react-relay';
import styles from './mobileNavMenuBody.scss';
import MobileNavAuthButtons from '../MobileNavAuthButtons/MobileNavAuthButtons';
import MobileNavDrilldownList from '../MobileNavDrilldown/MobileNavDrilldownList';

function MobileNavMenuBody(props) {
    return (
        <div className={props.className}>
            {props.sections.map(section => {
                return (
                    <div key={section.title}>
                        <div className={`${styles.item} ${styles.sectionTitle}`}>{section.title}</div>
                        <MobileNavDrilldownList items={section.items} onItemClick={props.onItemClick} />
                    </div>
                );
            })}
            <MobileNavAuthButtons user={props.user} onAuthClick={props.onAuthClick}/>
        </div>
    );
}


MobileNavMenuBody.defaultProps = {
    className: ''
};

MobileNavMenuBody.propTypes = {
    className: string,
    sections: array,
    onItemClick: func.isRequired,
    onAuthClick: func.isRequired,
    user: object
};

export default createFragmentContainer(
    MobileNavMenuBody,
    {
        user: graphql`
            fragment MobileNavMenuBody_user on User {
                ...MobileNavAuthButtons_user
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavMenu/MobileNavMenuBody.jsx